export const Features = {
  '2FA': '2fa',
  AccessControl: 'access-control',
  AccessTokenScope: 'access-token-scope',
  Activity: 'activity',
  ActivityAllowedHistoryInDays: 'activity-period',
  AdvancedPath: 'advanced-path',
  APIRequests: 'api-requests',
  Approval: 'approval',
  AssetFolders: 'asset-folders',
  Assets: 'assets',
  AutomaticUpdate: 'automatic-update',
  AutoSave: 'autosave',
  Backups: 'backups',
  BlokInk: 'blok-ink',
  Branches: 'branches',
  BrokenLinkChecker: 'storyblok-gmbh@broken-links-checker',
  Bynder: 'storyblok-gmbh@bynder',
  Centra: 'centra',
  Clipboard: 'clipboard',
  ClipboardHistory: 'clipboard-history',
  CloneProjects: 'clone-projects',
  Cloudinary: 'cloudinary',
  Comments: 'comments',
  Components: 'components',
  ContactPerson: 'contact-person',
  ContentLocking: 'content-locking',
  ContentVersions: 'content-versions',
  CustomFieldTypes: 'custom-field-types',
  CustomMetadata: 'custom-metadata',
  CustomRoles: 'custom-roles',
  CustomWorkflows: 'custom-workflows',
  CustomWorkflowStages: 'custom-workflow-stages',
  Datasources: 'datasources',
  DeliveryAPI: 'delivery-api',
  Dimensions: 'dimensions',
  Docs: 'docs',
  ECommerce: 'ecommerce',
  Export: 'export',
  ExtendedActivity: 'extended-activity',
  Folders: 'folders',
  Forced2FA: 'forced-2fa',
  GraphQL: 'graphql',
  HasAdditionalUsageAssets: 'has_additional_usage_assets',
  HasAdditionalUsageStories: 'has_additional_usage_stories',
  ImageOptimization: 'image-optimization',
  Import: 'import',
  Internationalization: 'internationalization',
  LanguageImportExport: 'language-import-export',
  Languages: 'languages',
  Locales: 'locales',
  Lokalise: 'lokalise',
  ManagementAPI: 'management-api',
  MaxAssetSize: 'max-asset-size',
  MaxUsers: 'max-users',
  NetlifyBuilds: 'storyblok-gmbh@netlify',
  Optimizely: 'optimizely',
  OrganizationAnalytics: 'organization-analytics',
  PipelineStages: 'pipeline-stages',
  PipelineStaging: 'pipeline-staging',
  PlanUsers: 'plan-users',
  PreviewEnvironments: 'preview-environments',
  Releases: 'releases',
  ReleasesOnly: 'releases_only',
  ReplaceAsset: 'replace_asset',
  ResponsivePreview: 'responsive-preview',
  RestrictedIP: 'restricted-ip',
  S3BackupFrequency: 's3_backup_frequency',
  Saleor: 'saleor',
  SDKs: 'sdks',
  SearchQuery: 'search-query',
  SEOMetaTags: 'seo-meta-tags',
  SharedComponents: 'shared-components',
  SharedSpace: 'sharedspace',
  Shopify: 'shopify',
  Stories: 'stories',
  TaskManager: 'task-manager',
  TranslatableSlugs: 'translatable-slugs',
  VisualEditor: 'visual-editor',
  WebHooks: 'webhooks',
  WebHookSecrets: 'webhook-secrets',
  WireTransfer: 'wire-transfer',
  Workflows: 'workflows',
} as const
